/**
 * Cart nudge / cart cutoff templates: legacy Firestore bodies may omit `--itemsHtml--`
 * or the cart CTA. Mirrors `emailtransporter.js` (sendCartCutoffReminderEmail, etc.)
 * so Email Template Studio live preview matches the HTML merged before send.
 */

import { getWholesaleCartUrl, emailCartCtaButtonDirectHtml } from './emailBrandStyles';

/**
 * @param {string} html - raw template HTML from `email_templates`
 * @param {object} [info] - merge payload (`itemsHtml`, `cartUrl`)
 * @returns {string}
 */
export function applyCartNudgeTemplateHtmlTransforms(html, info = {}) {
    let out = String(html ?? '');
    const ih = String(info?.itemsHtml ?? '').trim();
    if (ih && !/--itemsHtml--/.test(out)) {
        if (/<pre[\s>]/i.test(out)) {
            out = out.replace(/<pre\b/i, `${ih}<pre`);
        } else if (out.includes('</div>')) {
            const last = out.lastIndexOf('</div>');
            out = `${out.slice(0, last)}${ih}${out.slice(last)}`;
        }
    }

    const cartUrlResolved = (info && info.cartUrl) || getWholesaleCartUrl();
    if (
        cartUrlResolved &&
        !/--cartUrl--/.test(out) &&
        !/View your cart/i.test(out) &&
        /<pre[\s>]/i.test(out)
    ) {
        out = out.replace(/<pre\b/i, `${emailCartCtaButtonDirectHtml(cartUrlResolved)}<pre`);
    }
    return out;
}
